"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addListener = exports.getPrefersColorScheme = exports.prefersColorSchemeQueries = exports.prefersColorSchemeDarkQuery = exports.prefersColorSchemeLightQuery = exports.syncDocumentBodyClassName = exports.documentBody = void 0;

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var constants_1 = require("../constants"); // Note: required for SSR Compatibility


var mockDocumentBody = {
  classList: {
    add: utils_1.noop,
    remove: utils_1.noop
  }
};
exports.documentBody = utils_1.isBrowser ? document.body : mockDocumentBody;

function syncDocumentBodyClassName(product, isDark) {
  exports.documentBody.classList.add(isDark ? constants_1.classNames[product].dark : constants_1.classNames[product].light);
  exports.documentBody.classList.add(isDark ? constants_1.classNames[product].light : constants_1.classNames[product].dark);
}

exports.syncDocumentBodyClassName = syncDocumentBodyClassName;

function getMediaQuery(query) {
  var mediaQueryList = window.matchMedia(query);
  var matches = !!mediaQueryList.media === mediaQueryList.matches;
  return matches;
}

exports.prefersColorSchemeLightQuery = '(prefers-color-scheme: light)';
exports.prefersColorSchemeDarkQuery = '(prefers-color-scheme: dark)';
exports.prefersColorSchemeQueries = {
  light: exports.prefersColorSchemeLightQuery,
  dark: exports.prefersColorSchemeDarkQuery
};

function getPrefersColorScheme() {
  var isDark = getMediaQuery(exports.prefersColorSchemeQueries.dark);
  return isDark ? 'dark' : 'light';
}

exports.getPrefersColorScheme = getPrefersColorScheme;
;

function addListener(fn) {
  if (!window.hasOwnProperty('matchMedia')) {
    return undefined;
  }

  var mediaQueryList = window.matchMedia(exports.prefersColorSchemeQueries.dark);

  var listener = function listener() {
    fn(mediaQueryList.matches ? 'dark' : 'light');
  };

  listener();
  mediaQueryList.addListener(listener);
  return function () {
    mediaQueryList.removeListener(listener);
  };
}

exports.addListener = addListener;